// @flow

import React from 'react';

import { EstimateContextProvider } from '../../../contexts/EstimateContextProvider';
import { ClusterContextProvider } from '../../../contexts/ClusterContextProvider';
import { MonthlyInputsMetaDataContextProvider } from '../../../contexts/MonthlyInputsMetaDataContextProvider';
import { ClusterBreadcrumbs } from '../../breadcrumbs/ClusterBreadcrumbs';
import { ShowLoaderIfAnyQueryIsPending } from '../../presentational/ShowLoaderIfAnyQueryIsPending';
import { UserContextProvider } from '../../../contexts/UserContextProvider';
import { ConnectorsContextProvider } from '../../../contexts/ConnectorsContextProvider';
import { AiAssistantEstimateContextBridge } from '../../ai-assistant/AiAssistantEstimateContextBridge';

import { ClusterTopLevelContainerForm } from './ClusterTopLevelContainerForm';

const ClusterTopLevelContainer = () => {
  return (
    <>
      <ShowLoaderIfAnyQueryIsPending />
      <UserContextProvider>
        <EstimateContextProvider>
          <AiAssistantEstimateContextBridge />
          <MonthlyInputsMetaDataContextProvider>
            <ConnectorsContextProvider>
              <ClusterContextProvider>
                <ClusterBreadcrumbs />
                <ClusterTopLevelContainerForm />
              </ClusterContextProvider>
            </ConnectorsContextProvider>
          </MonthlyInputsMetaDataContextProvider>
        </EstimateContextProvider>
      </UserContextProvider>
    </>
  );
};

export default ClusterTopLevelContainer;
